<tr-connection-alert></tr-connection-alert>
<angular-alerts-outlet></angular-alerts-outlet>
<tr-loader></tr-loader>
<router-outlet></router-outlet>
